export default __webpack_public_path__ + "static/media/avatar_madalina_muntean.e8d680b1.png";